import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.679 5.344H.32a.346.346 0 0 1-.227-.083A.265.265 0 0 1 0 5.062V3.938c0-.074.034-.146.094-.198a.346.346 0 0 1 .227-.083H23.68c.085 0 .167.03.227.083.06.052.094.124.094.199v1.124a.265.265 0 0 1-.094.2.346.346 0 0 1-.227.082Zm0 7.5H.32a.346.346 0 0 1-.227-.083.265.265 0 0 1-.094-.198v-1.126c0-.074.034-.146.094-.198a.346.346 0 0 1 .227-.083H23.68c.085 0 .167.03.227.083.06.052.094.124.094.198v1.126a.265.265 0 0 1-.094.198.347.347 0 0 1-.227.083Zm0 7.5H.32a.346.346 0 0 1-.227-.083.265.265 0 0 1-.094-.198v-1.125c0-.075.034-.147.094-.2a.346.346 0 0 1 .227-.082H23.68c.085 0 .167.03.227.083.06.052.094.124.094.198v1.125a.265.265 0 0 1-.094.2.347.347 0 0 1-.227.082Z"
    }, null, -1)
  ])))
}
export default { render: render }